export function listingMatchesSearch(listing, searchTerm) {
  if (!searchTerm) return true;

  const searchLower = searchTerm.toLowerCase();
  return (
    listing.title?.toLowerCase().includes(searchLower) ||
    listing.location_name?.toLowerCase().includes(searchLower) ||
    listing.region?.toLowerCase().includes(searchLower) ||
    listing.description?.toLowerCase().includes(searchLower) ||
    listing.nearby_bases?.some((base) => base.toLowerCase().includes(searchLower))
  );
}

export function compareListingsForRelocation(a, b) {
  if (a.is_early_access && !b.is_early_access) return -1;
  if (!a.is_early_access && b.is_early_access) return 1;

  const aAvailable = a.availability_status === 'AVAILABLE' || a.days_until_available === 0;
  const bAvailable = b.availability_status === 'AVAILABLE' || b.days_until_available === 0;
  if (aAvailable && !bAvailable) return -1;
  if (!aAvailable && bAvailable) return 1;

  const confidenceRank = { HIGH: 0, MEDIUM: 1, LOW: 2 };
  const aConfidence = confidenceRank[a.availability_confidence] ?? 3;
  const bConfidence = confidenceRank[b.availability_confidence] ?? 3;
  if (aConfidence !== bConfidence) return aConfidence - bConfidence;

  const aDays = Number.isFinite(a.days_until_available) ? a.days_until_available : Number.POSITIVE_INFINITY;
  const bDays = Number.isFinite(b.days_until_available) ? b.days_until_available : Number.POSITIVE_INFINITY;
  if (aDays !== bDays) return aDays - bDays;

  const aReviews = a.review_count || 0;
  const bReviews = b.review_count || 0;
  if (aReviews !== bReviews) return bReviews - aReviews;

  return (a.total_monthly_cost ?? a.base_amount ?? Number.POSITIVE_INFINITY)
    - (b.total_monthly_cost ?? b.base_amount ?? Number.POSITIVE_INFINITY);
}

export function processListingsForDisplay(listings, searchTerm) {
  return [...(listings || [])]
    .filter((listing) => listingMatchesSearch(listing, searchTerm))
    .sort(compareListingsForRelocation);
}
